import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
} from "@mui/material";
import { useAuthStore } from "../store/useAuthStore";
import Loader from "./Loader/Loader";

const EditProfile = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    profileImage: null,
    address: {
      phone: "",
      streetAddress: "",
      apartmentOrSuite: "",
      city: "",
      state: "",
      zipCode: "",
      country: "United States",
    },
  });
  const { updateUser, loading, authUser } = useAuthStore()
  const [previewUrl, setPreviewUrl] = useState(null);
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "profileImage") {
      setFormData((prev) => ({ ...prev, profileImage: files[0] }));
      setPreviewUrl(URL.createObjectURL(files[0]));
    } else if (name.startsWith("address.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);

    try {
      await updateUser(formData)
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {

    if (authUser) {
      if (authUser) {
        setFormData((prev) => ({
          ...prev,
          fullName: authUser?.fullName || "",
          profileImage: authUser?.avatar || null,
          address: {
            phone: authUser?.address?.phone || "",
            streetAddress: authUser?.address?.streetAddress || "",
            apartmentOrSuite: authUser?.address?.apartmentOrSuite || "",
            city: authUser?.address?.city || "",
            state: authUser?.address?.state || "",
            zipCode: authUser?.address?.zipCode || "",
            country: authUser?.address?.country || "United States",
          },
        }));
        setPreviewUrl(authUser?.avatar)
      }

    }
  }, [])

  return (
    <Box
      sx={{
        border: "1px solid #C6C4C4",
        borderRadius: "13px",
        padding: "20px",
      }}
    >
      <Loader loading={loading} />
      <Typography
        variant="h2"
        sx={{
          fontFamily: `"Quicksand", sans-serif`,
          fontWeight: 700,
          fontSize: { xs: "16px", md: "16px", lg: "20px" },
          lineHeight: "28px",
          color: "#008BFF",
          textAlign: "left",
          textTransform: "capitalize",
        }}
      >
        Edit Your Profile
      </Typography>

      <Box
        component="form"
        sx={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
          gap: "12px",
          flexWrap: "wrap",
          "& label": {
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "400",
            fontFamily: `"Lato", sans-serif`,
            color: "#000",
            marginBottom: "10px",
          },
          "& input": {
            height: "50px",
            paddingTop: "0",
            paddingBottom: "0",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "4px",
          },
          "& .MuiInputBase-root.MuiFilledInput-root::before": {
            content: "none",
          },
          "& .MuiFormControl-root": {
            width: "100%",
          },
          "& input::placeholder": {
            color: "#999999",
          },
          "& .formControl": {
            width: "48%",
          },
        }}
        noValidate
        autoComplete="off"
      >
        <FormControl className="formControl">
          <label>Full Name</label>
          <TextField
            name="fullName"
            placeholder="Md"
            type="text"
            variant="filled"
            value={formData.fullName}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Address</label>
          <TextField
            name="address.streetAddress"
            placeholder="123 Street, City"
            type="text"
            variant="filled"
            value={formData.address.streetAddress}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Phone</label>
          <TextField
            name="address.phone"
            placeholder="+1 555 000 1234"
            type="text"
            variant="filled"
            value={formData.address.phone}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Apartment or Suite</label>
          <TextField
            name="address.apartmentOrSuite"
            placeholder="Suite 202"
            type="text"
            variant="filled"
            value={formData.address.apartmentOrSuite}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>City</label>
          <TextField
            name="address.city"
            placeholder="New York"
            type="text"
            variant="filled"
            value={formData.address.city}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>State</label>
          <TextField
            name="address.state"
            placeholder="NY"
            type="text"
            variant="filled"
            value={formData.address.state}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Zip Code</label>
          <TextField
            name="address.zipCode"
            placeholder="10001"
            type="text"
            variant="filled"
            value={formData.address.zipCode}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Country</label>
          <TextField
            name="address.country"
            placeholder="United States"
            type="text"
            variant="filled"
            value={formData.address.country}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl className="formControl">
          <label>Profile Image</label>
          <input
            name="profileImage"
            type="file"
            accept="image/*"
            onChange={handleChange}
          />
        </FormControl>
        {previewUrl && (
          <img
            src={previewUrl}
            alt="Preview"
            style={{ marginTop: "0.5rem", height: "80px" }}
          />
        )}

      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          marginTop: "30px",
          "& a": {
            fontSize: "16px",
            lineHeight: "24px",
            marginRight: "30px",
            color: "#000",
          },
        }}
      >
        <a href="/login">Cancel</a>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            display: "block",
            textAlign: "center",
            background: "#008BFF",
            width: "203px",
            height: {
              xs: "36px",
              sm: "36px",
              md: "45px",
              lg: "56px",
            },
            borderRadius: "4px",
            color: "#FAFAFA",
            boxShadow: "none",
            fontFamily: `"Quicksand", sans-serif`,
            fontWeight: 500,
            fontSize: {
              xs: "12px",
              sm: "15px",
              md: "15px",
              lg: "16px",
            },
            lineHeight: {
              xs: "18px",
              sm: "20px",
              md: "22px",
              lg: "24px",
            },
            textTransform: "capitalize",
          }}
        >
          Saving Changes
        </Button>
      </Box>
    </Box>
  );
};

export default EditProfile;
